
import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { UserModel } from '../_models/user.model';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthFongesoftGuard implements CanActivate {
  constructor(private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
     
    this.setDummyUser("");
    
    if (this.authService.getUser()) {

      return true;
    }

    this.authService.logout();
    return false;
  }

  private setDummyUser(region) {
    let u: UserModel = {
        name: "",
        email: "",
        token: "",
        region: region,
        url: region,
        identifiant: "",
        nom: "",
        prenom: "",
        role: "",
        autorisation: [],
        preferences: "",
    };
    sessionStorage.setItem("user",JSON.stringify(u));
    return u;
}

}
